module.exports = __webpack_public_path__ + "img/github.9ac279f9.png";